import { idConnectStorage } from './idConnectStorage';
import { IdConnectConfiguration, IdGraphType } from '@idConnect/types';
import { getAdtechpassValueProxy } from '@shared/helpers/idGraph/getAdtechpassValueProxy';

export const getAllIdGraphEntries = (
  idConnectConfiguration: IdConnectConfiguration,
): IdGraphType[] | null => {
  const idConnectStorageData = idConnectStorage(
    idConnectConfiguration.IDCONNECT_STORAGE_TYPE,
  ).get(idConnectConfiguration.IDCONNECT_DATA_STORAGE);
  const isIdConnectStorageDataDefined: boolean =
    idConnectStorageData !== undefined && idConnectStorageData !== null;

  if (
    isIdConnectStorageDataDefined &&
    Array.isArray(idConnectStorageData?.connectId?.idGraph)
  ) {
    const idGraphDomain = idConnectStorageData?.connectId?.domain;
    const idGraph: IdGraphType[] = idConnectStorageData.connectId.idGraph.map(
      (entry: IdGraphType) => ({
        ...entry,
        atid: getAdtechpassValueProxy(entry.atid),
        domain: idGraphDomain,
      }),
    );

    return idGraph;
  } else {
    return null;
  }
};
